<template>
    <div class="table-container-with-inspect pd" :class="{hasInspector, inspecting}">
        <div class="table-container">
            <div class="table" ref="table" :class="{rowshadow, hasPaginatorTop, isEmpty, hasHeader}">

                <slot name="header">
                    <div class="table-header">
                        <span v-if="table && table.name">{{ table.name }}</span>
                    </div>
                </slot>

                <transition name="fade-up">
                    <div class="actions-bar" v-if="hasActions">
                        <slot name="actions"></slot>
                    </div>
                </transition>

                <div class="inline-paginator">
                    <slot name="paginatorTop"></slot>
                </div>

                <div class="headers">
                    <slot name="headers">
                        <template v-if="table">
                            <sc-table-header :table="table" v-for="(column,name) in columns" :field="name"
                                             :key="name">
                                {{ replaceUnderscores(name) }}
                            </sc-table-header>
                            <div class="overflow-header" v-show="table.overflowing">more</div>
                        </template>
                    </slot>

                </div>

                <div class="rows-container">
                    <div class="loader" v-if="loading > 0 || (table && table.loading > 0)"></div>
                    <div class="rows" :class="{loading: loading > 0 || (table && table.loading > 0)}">

                        <slot name="rows">
                            <template v-if="table">
                                <template v-if="table.hasData === true">
                                    <sc-table-row v-for="row in table.rows()" :key="row.id" :clickable="table.hover"
                                                  :overflowing="table.overflowing"
                                                  @click.native="$emit('view',row)">


                                        <sc-table-cell-base v-for="(column,name) in columns" :field="name"
                                                            :table="table" :key="name">

                                            <slot :name="'column-' + name" :row="row">
                                                <sc-table-cell :table="table" :field="name">

                                                    <template v-if="column.type === 'date'">
                                                        {{ getColumnValueDateHuman(row, column, name) }}
                                                        <template slot="sub">
                                                            {{ getColumnValueDateTime(row, column, name) }}
                                                        </template>
                                                    </template>

                                                    <template v-else-if="column.type === 'boolean'">
                                                        <template v-if="getColumnValue(row, column, name) === 1">
                                                            <template v-if="typeof column.booleanTrue !== 'undefined'">
                                                                {{ column.booleanTrue }}
                                                            </template>
                                                            <template v-else>
                                                                <awesome-icon icon="check"></awesome-icon>
                                                            </template>
                                                        </template>
                                                        <template v-else>
                                                            <template v-if="typeof column.booleanFalse !== 'undefined'">
                                                                {{ column.booleanFalse }}
                                                            </template>
                                                            <template v-else>
                                                                <awesome-icon icon="times"></awesome-icon>
                                                            </template>
                                                        </template>

                                                    </template>

                                                    <template v-else-if="column.type === 'user'">
                                                        <sc-table-user :user="row[name]"></sc-table-user>
                                                    </template>

                                                    <template v-else>
                                                        {{ getColumnValue(row, column, name) }}
                                                    </template>

                                                </sc-table-cell>
                                            </slot>

                                        </sc-table-cell-base>

                                        <template #overflowy>
                                            <sc-table-cell-base v-for="(column,name) in columns" :field="name"
                                                                v-if="column.overflowing" :inOverflowMenu="true"
                                                                :table="table" :key="name">

                                                <slot :name="'column-' + name" :row="row">
                                                    <sc-table-cell :table="table" :field="name">

                                                        <template v-if="column.type === 'date'">
                                                            {{ getColumnValueDateHuman(row, column, name) }}
                                                            <template slot="sub">
                                                                {{ getColumnValueDateTime(row, column, name) }}
                                                            </template>
                                                        </template>

                                                        <template v-else-if="column.type === 'boolean'">
                                                            <template v-if="getColumnValue(row, column, name) === 1">
                                                                <template
                                                                        v-if="typeof column.booleanTrue !== 'undefined'">
                                                                    {{ column.booleanTrue }}
                                                                </template>
                                                                <template v-else>
                                                                    <awesome-icon icon="check"></awesome-icon>
                                                                </template>
                                                            </template>
                                                            <template v-else>
                                                                <template
                                                                        v-if="typeof column.booleanFalse !== 'undefined'">
                                                                    {{ column.booleanFalse }}
                                                                </template>
                                                                <template v-else>
                                                                    <awesome-icon icon="times"></awesome-icon>
                                                                </template>
                                                            </template>

                                                        </template>

                                                        <template v-else-if="column.type === 'user'">
                                                            <sc-table-user :user="row[name]"></sc-table-user>
                                                        </template>

                                                        <template v-else>
                                                            {{ getColumnValue(row, column, name) }}
                                                        </template>

                                                    </sc-table-cell>
                                                </slot>

                                            </sc-table-cell-base>
                                        </template>
                                    </sc-table-row>
                                </template>
                            </template>
                        </slot>


                    </div>
                    <div class="no-records" v-if="isEmpty">
                        <div class="no-records-icon">
                            <awesome-icon icon="table"></awesome-icon>
                        </div>
                        <div class="descr">
                            <slot name="empty">No items found</slot>
                        </div>
                    </div>
                </div>
            </div>
            <div class="paginator-bottom">
                <slot name="paginator" v-if="hasPaginatorBottom"></slot>
                <sc-paginate style="margin-top:8px;" v-else-if="table" :table="table"></sc-paginate>
            </div>
        </div>
        <div class="inspector" :style="{flex:inspectFlex}" v-show="hasInspector">
            <slot name="inspector"></slot>
        </div>
    </div>
</template>

<script>
import moment from 'moment-timezone'

export default {
  name: "sc-table",
  props: {
    rowshadow: {},
    data: {},
    loading: {
      default: 0,
      type: Number,
    },
    actionsVisible: {
      default: false,
      type: Boolean,
    },
    inspecting: {
      default: false,
    },
    inspectFlex: {
      default: 2
    },
    table: {}
  },

  data() {
    return {
      widthCurrent: 0,
    }
  },

  computed: {

    columns() {
      let columns = this.table.columns;
      for (const [k, v] of Object.entries(columns)) {
        if (v.guard !== false) {
          delete columns[k]
        }
      }
      return columns;
    },

    hasPaginatorTop() {
      return !!this.$slots['paginatorTop']
    },

    hasPaginatorBottom() {
      return !!this.$slots['paginator']
    },

    hasHeader() {
      return this.hasName || this.hasButton || this.hasFilters || this.hasDescription || (this.table && this.table.name)
    },

    hasHeaders() {
      return !!this.$slots['headers']
    },

    hasRows() {
      return !!this.$slots['rows']
    },

    hasInspector() {
      return !!this.$slots['inspector']
    },

    hasName() {
      return !!this.$slots['name']
    },

    hasDescription() {
      return !!this.$slots['description']
    },

    hasButton() {
      return !!this.$slots['button']
    },

    hasFilters() {
      return !!this.$slots['filters']
    },

    isEmpty() {
      if (this.table && this.table.hasData === true && this.table.rows().length === 0) {
        return true;
      } else if (this.data && this.data.total === 0) {
        return true;
      }
    },

    hasActions() {
      return !!this.$slots['actions'] && this.actionsVisible;
    }

  },

  mounted() {
    this.$nextTick(() => {
      this.resize();
    })
    addEventListener('resize', this.resize)
  },

  beforeDestroy() {
    removeEventListener('resize', this.resize)
  },

  methods: {

    resize() {
      if (this.$refs.table) {
        this.table.updateColumnOverflows(this.$refs.table.clientWidth);
      }
    },

    getColumnValueDateHuman(row, column, columnName) {
      let date = this.getColumnValue(row, column, columnName);
      if (date) {
        let m = moment.tz(date, 'UTC');
        let adjusted = m.tz(moment.tz.guess()).fromNow();
        return adjusted;
      } else {
        return;
      }
    },

    getColumnValueDateTime(row, column, columnName) {
      let date = this.getColumnValue(row, column, columnName);
      if (date) {
        let m = moment.tz(date, 'UTC');
        let adjusted = m.tz(moment.tz.guess()).format('D-MM-Y, HH:mm');
        return adjusted
      } else {
        return;
      }
    },


    getColumnValue(row, column, columnName) {
      let target = columnName;
      if (column.target && column.target !== '') {
        target = column.target;
      }
      if (target.includes('.')) {
        return target.split('.').reduce((o, i) => {
          if (o && o.hasOwnProperty(i)) {
            return o[i]
          }
        }, row)
      } else {
        return row[target]
      }
    },

    replaceUnderscores(value) {
      if (value) {
        return value.replace(new RegExp('_', 'g'), ' ')
      }
    }
  }
}
</script>

<style scoped lang="scss">
.table-container-with-inspect {
    position: relative;
    padding: 28px 32px;
    box-sizing: border-box;
}

.table-container {
    padding: 0;
    box-sizing: border-box;

    // Table design
    background: #fff;
    border-radius: 0.3em;
    box-shadow: $shading;
    min-width:300px;
}

.table {
    position: relative;
    border-radius: 5px 5px 0 0;
    min-width:300px;
}

.table.rowshadow {
    box-shadow: none;
}

.headers {
    border-bottom: 1px solid rgba(0, 0, 0, 0.05);
    border-radius: 5px 5px 0 0;
    padding: 0 16px;
    width: 100%;
    box-sizing: border-box;
    z-index: 2;
    position: relative;
    display: flex;

    font-weight: 700;
    text-transform: capitalize;
    font-size: 0.7em;

    overflow: hidden;
}

.hasHeader .headers {
    border-radius: 0;
}

.isEmpty .headers {
    pointer-events: none;
}

.hasPaginatorTop .headers {
    border-radius: 0;
}

.rowshadow .headers {
    /*box-shadow: $shading;*/
}

.rows > div:last-child {
    border: none;
    border-radius: 0 0 5px 5px;
    /*overflow: auto;*/
}

.inline-paginator .paginator-container {
    padding: 0 0 0px;
    border-bottom: 1px solid #fafafa;
}

.inline-paginator .paginator-container .widget.paginator {
    border-radius: 0;
}

.no-records {
    padding: 48px 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    color: #ccc;
}

.no-records .descr {
    font-weight: 700;
    text-transform: uppercase;
    font-size: 0.8em;
}

.no-records .no-records-icon {
    color: #eee;
    font-size: 5em;
    padding-bottom: 8px;
}

.theme--dark .no-records {
    color: #999;

    .no-records-icon {
        color: #999;
    }
}

.rows-container {
    position: relative;
    min-height: 50px;
}

.table.rowshadow .rows-container {
    min-height: 0;
    background: transparent;
}

.rows:after {
    content: '';
    display: block;
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    background: rgba(255, 255, 255, 0.6);
    opacity: 0;
    transition: opacity .2s ease-in-out;
    pointer-events: none;
}

.theme--dark .rows:after {
    background: rgba(50, 50, 50, 0.8);
}

.rows.loading:after {
    opacity: 1;
}

.loader {
    position: absolute;
    top: -3px;
    left: 0;
    right: 0;
    height: 4px;
    transition: background .15s ease-in-out;
    color: #fff;
    font-size: 1em;
    font-weight: 700;
    overflow: hidden;
    z-index: 5;
}

.loader:after {
    content: '';
    display: block;
    position: absolute;
    left: 0;
    height: 100%;
    background: rgba(27, 39, 112, 0.4);
    animation: rowloader 2s ease-in-out infinite;
}

.theme--dark .loader:after {
    background: #d52e30;
}

@keyframes rowloader {
    0% {
        left: 0;
        width: 0;
        opacity: 0;
    }
    30% {
        left: 0;
        opacity: 1;
        width: 100%;
    }
    100% {
        left: 100%;
        width: 0%;
    }
}

.actions-bar {
    width: 100%;
    position: absolute;
    left: 0;
    right: 0;
    /*background: $color-primary;*/
    background: #515b6b;
    color: #fff;
    transform: translateY(calc(-100% + 4px));
    padding: 8px 32px 12px;
    box-sizing: border-box;
    z-index: 1;
    border-radius: 5px 5px 0 0;
    display: flex;
}

.theme--dark .actions-bar {
    background: #1d1d1d;
}

.fade-up-enter-active {
    transition-property: opacity, transform;
    transition-duration: $transition-duration;
    transition-timing-function: $easing;
}

.fade-up-enter {
    opacity: 0;
    transform: translateY(-40%);
}

.fade-up-enter-to {
    opacity: 1;
    transform: translateY(calc(-100% + 4px));
}

.fade-up-leave-active {
    transition-property: opacity;
    transition-duration: $transition-duration;
    transition-timing-function: $easing;
}

.fade-up-leave {
    opacity: 1;
}

.fade-up-leave-to {
    opacity: 0;
}

.table-header .table-name .name {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.table-header .table-name .name span {
    padding: 0.85em 0;
}

.table-name .description {
    font-weight: 500;
    text-transform: initial;
    margin-top: 0.8em;
    font-size: 0.8em;
    line-height: 1.3em;
}

.overflow-header {
    padding: 12px 0;
    position: absolute;
    top: 0;
    right: 14px;
}


</style>